export const ArrowLeftIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    {/* Arrow with vertical bar in front with space */}
    <path d="M4 4v16" stroke="currentColor" strokeWidth="2" />
    <path d="M20 11H11l4.5-4.5L14 5l-7 7 7 7 1.5-1.5L11 13h9v-2z" />
  </svg>
);
